import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import createReactClass from 'create-react-class'
import classNames from 'classnames';
import s from './Grid.css';

class Grid extends React.Component {
  render() {
    return <div className={s.Gridcell}>
      {this.props.children}
    </div>
  }
}

Grid.propTypes = {
  middle: PropTypes.bool,
  bottom: PropTypes.bool,
  center: PropTypes.bool,
  right: PropTypes.bool,
  sides: PropTypes.bool,
  withGutter: PropTypes.bool,
  withGutter2x: PropTypes.bool,
  equalHeight: PropTypes.bool,
  className: PropTypes.string,
};

Grid.Cell = createReactClass({
  render() {
    const className = this.props.className;
    if (typeof className !== 'undefined') {
      
      const elements = className.split(' ');
      let myClassName = '';
      for (let i = 0; i < elements.length; i += 1) {
        if (`${s[elements[i]]}` !== undefined) {
          if (myClassName === '') {
            myClassName += `${s[elements[i]]}`;
          } else {
            myClassName += ` ${s[elements[i]]}`;
          }
        }
      }
      return (
        <div className={`${s.Gridcell} ${myClassName}`}>
          {this.props.children}
        </div>
      );
    }
    return (
      <div className={s.Gridcell}>
        {this.props.children}
      </div>
    );
  },
});

export default withStyles(s)(Grid);



// WEBPACK FOOTER //
// ./src/components/Grid/Grid.js